import React from 'react';

const ServiceCard2 = ({ 
  title, 
  description, 
  icon, 
  className = "bg-white border-[#f6f6f6] p-[20px] md:p-[32px] border-2 md:border-4",
  iconWrapperClass = "bg-[#8fc0451a] border-[#8fc0451a]",
  iconWrapperSizeClass = "w-[48px] h-[48px] md:w-[72px] md:h-[72px]",
  iconSizeClass = "w-[24px] h-[24px] md:w-[40px] md:h-[40px]",
  titleClass = "text-[16px] md:text-[20px]",
  descClass = "text-[#6a7282] text-[14px] leading-[20px] md:text-[16px] md:leading-[24px]"
}) => {
  return (
    <div className={`border-solid flex flex-col gap-[12px] md:gap-[16px] items-start relative rounded-[16px] w-full h-full text-left ${className}`}>
      <div className={`border-2 border-solid flex items-center justify-center p-[2px] relative rounded-[12px] shrink-0 ${iconWrapperSizeClass} ${iconWrapperClass}`}>
        <div className={`relative shrink-0 flex items-center justify-center ${iconSizeClass}`}>
          {icon ? (
            icon
          ) : (
            <img src="/imgs/folder-02.svg" alt="" className="max-w-none w-full h-full" />
          )}
        </div>
      </div>
      <div className="flex flex-col gap-[8px] md:gap-[12px] items-start not-italic relative shrink-0 w-full">
        <p className={`font-bold leading-[20px] relative shrink-0 text-[#262f39] w-full m-0 ${titleClass}`}>
          {title || "Modello 730"}
        </p>
        <p className={`font-normal relative shrink-0 w-full m-0 ${descClass}`}>
          {description || "La tua dichiarazione dei redditi verificata da esperti."}
        </p>
      </div>
    </div>
  );
};

export default ServiceCard2;
